export default {
    template: '#realty-search-results-button',
    props: {
        results: {
            type: Number,
            required: true,
            default: 0,
        },
        singularLabel: {
            type: String,
            required: true,
            default: '',
        },
        pluralLabel: {
            type: String,
            required: true,
            default: '',
        },
    },
    computed: {
        label() {
            if (this.results === 1) {
                return this.singularLabel.replace('%d', this.results);
            } else {
                return this.pluralLabel.replace('%d', this.results);
            }
        },
    },
};
